function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

if(window.innerWidth>750){
    var wFlag=true
}else{
    wFlag=false
}

$(()=>{
    //box2
    showUp('.box2_title')
    ScrollTrigger.create({
        trigger:'.box2_items',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box2_items div',{opacity:0,y:'2rem',stagger:0.2})
    })

    //box3
    showUp('.box3_title')
    showUp('.box3_info')
    showUp('.box3_img')
    
    ScrollTrigger.create({
        trigger:'.box3',
        start:wFlag?'top top+=6%':'top top+=10%',
        end:'+=60%',
        scrub:1,
        pin:true,
        // markers:true,
        animation:gsap.timeline()
            .from('.box3_img img:nth-child(2)',{opacity:0})
            .from('.box3_img img:nth-child(3)',{opacity:0})
            .from('.box3_img img:nth-child(4)',{opacity:0})
    })

    //box4
    ScrollTrigger.create({
        trigger:'.box4',
        start:'top top+=6%',
        end:'+=100%',
        scrub:1,
        // markers:true,
        animation:gsap.timeline()
            .to('.box4_img1',{y:wFlag?'-72rem':'-52rem'})
            .to('.box4_img2',{y:wFlag?'-72rem':'-52rem'},'-=85%')
            .to('.box4_img3',{y:wFlag?'-72rem':'-52rem'},'-=95%')
    })
    ScrollTrigger.create({
        trigger:'.box4',
        start:'top+=90% top+=6%',
        end:'+=100%',
        scrub:1,
        // markers:true,
        animation:gsap.timeline()
            .to('.box4_content div',{opacity:0,duration:0.1})
            .from('.box4_img',{scale:4,rotate:'-360deg',opacity:0},'-=30%')
            .from('.box4_title',{opacity:0,duration:0.1},'-=80%')
    })
    ScrollTrigger.create({
        trigger:'.box4',
        start:'top top+=6%',
        end:'+=230%',
        pin:true,
    })

    //box5
    showUp('.box5_title')
    ScrollTrigger.create({
        trigger:'.box5',
        start:wFlag?'top top+=6%':'top top+=10%',
        end:'+=50%',
        scrub:1,
        pin:true,
        // markers:true,
        animation:gsap.timeline()
            .to('.box5 img',{scale:1.8,y:'12%'})
            .to('.gsap_flag',{opacity:0},'<')
            .from('.box5_line',{opacity:0,y:'-2rem'})
    })

    //box6
    showUp('.box6_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box6',
            start:'top+=10% top+=9%',
            end:'+=60%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .to('.box6_item',{x:'-27%'})
        })
        ScrollTrigger.create({
            trigger:'.box6',
            start:'top top+=9%',
            end:'+=90%',
            pin:true
        })
    }

    //box7
    ScrollTrigger.create({
        trigger:'.box7',
        start:'top center+=10%',
        end:'+=150%',
        scrub:1,
        animation:gsap.timeline()
            .from('.box7 div',{x:'100%'})
    })

    //box8
    showUp('.box8_title')
    new Swiper('.box8Swiper', {
        speed:12000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          //waitForTransition: false,
        },
        slidesPerView :2,
        loop:true
    })

    //box9
    showUp('.box9_title')
    ScrollTrigger.create({
        trigger:'.box9',
        start:'top top+=20%',
        end:'+=10%',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 10);
            $('.box9_item img:last-child').toggleClass('box9_active',index>2)
        }
    })

    //box10
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box10',
            start:'top+=10% top+=9%',
            end:'+=30%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .from('.box10_flag',{y:'-2%',scale:2.1})
                .from('.box10_title',{opacity:0,y:'2rem',duration:0.1})
        })
        ScrollTrigger.create({
            trigger:'.box10',
            start:'top+=60% top+=9%',
            end:'+=100%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .to('.box10_item',{x:'-50%'})
        })
        ScrollTrigger.create({
            trigger:'.box10',
            start:'top top+=9%',
            end:'+=170%',
            pin:true
        })
    }else{
        showUp('.box10_title')
    }

    //box11
    showUp('.box11_title')
    showUp('.b11_flag')

    showUp('.box12_title')
    //flavorsSwiper
    new Swiper('.flavorsSwiper', {
        slidesPerView:wFlag?3:1.5,
        centeredSlides: true,
        autoplay:true,
        navigation: {
            nextEl: '.flavorsSwiper-button-next',
            prevEl: '.flavorsSwiper-button-prev',
        }
    })

    //flavors specs package
    showUp('.flavors_title')
    showUp('.specs_img')
    showUp('.package_title')
})